<template>
  <div style="text-align: left;">
    <van-panel title="轻客账户信息" desc="请确认您的轻客账户余额信息" status="">
    </van-panel>
    <div style="text-align: center;">
      <div style="padding-left: 20px;padding-top: 15px;padding-right: 20px;text-align: left;">
        <div>轻客账户:{{pageData.phone}}</div>
        <div>轻币余额:{{pageData.balance}}</div>
      </div>
      <van-divider/>
      <div>
        <van-button size="normal" type="danger" color="#46C9BA" v-on:click="doMove">确认迁移</van-button>
      </div>
    </div>
    <div>
      <van-list @load="onLoad"></van-list>
    </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        pageData: {},
      }
    },
    methods: {

      onLoad: function () {
        this.loadPageData()
      },

      loadPageData: function () {
        let data = new FormData()
        let customerId = this.$route.query.customerId
        let phone = this.$route.query.phone
        data.append('customerId', customerId)
        data.append('phone', phone)

        this.$axios.post('/api/useraccountmove/get-oldsys-data', data).then(res => {
          if (res.data.success) {
            this.pageData = res.data.userObject
          } else {
            this.$toast.fail('加载失败，原因：' + res.data.msg + '!')
          }
          //加载状态结束
        }).catch(error => {
          this.$toast.fail('加载失败!')
        })
      },
      doMove () {

        this.$dialog.confirm({
          title: '提示',
          message: '确认进行进行迁移吗？',
        })
          .then(() => {
            this.doMoveSubmit()
          })
          .catch(() => {
            // on cancel
          })
      },

      doMoveSubmit () {
        let customerId = this.$route.query.customerId
        let bizCode = this.$route.query.bizCode
        let phone = this.$route.query.phone

        let data = new FormData()
        data.append('customerId', customerId)
        data.append('phone', phone)
        data.append('bizCode', bizCode)

        this.$axios.post('/api/useraccountmove/submit-move', data).then(res => {
          if (res.data.success) {
            this.jumpToResult()
          } else {
            this.$toast.fail('迁移失败，原因：' + res.data.msg + '!')
          }
          //加载状态结束
        }).catch(error => {
          this.$toast.fail('迁移失败!')
        })

      },

      jumpToResult () {
        let customerId = this.$route.query.customerId

        this.$dialog.alert({
          message: '账户迁移完成，请至[我的钱包]查看!',
        }).then(() => {
          this.$router.push({
            path: '/user/accountmove',
            query: {
              'customerId': customerId
            }

          })
        })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/user/AccountMoveConfirm.vue